module.exports = __webpack_public_path__ + "static/media/Mesa-Worm.5afc453a.png";


//////////////////
// WEBPACK FOOTER
// ./src/Img/productos/Mesa-Worm.png
// module id = 147
// module chunks = 0